module.exports = __webpack_public_path__ + "static/img/icon11.cc78285d.png";